export default __webpack_public_path__ + "static/media/channelcontimg.70e71599.PNG";